var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_688_12721)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 26.668H56.6663V53.3346H23.333V26.668Z",
    stroke: "white",
    strokeWidth: 2.50304
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 31.668L39.9997 41.668L56.6663 31.668",
    stroke: "white",
    strokeWidth: 2.50304
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_688_12721",
    x1: 0,
    y1: 0,
    x2: 80,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63F3F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedmail);
export default __webpack_public_path__ + "static/media/redmail.096150ffcd5eb64b6a368ac519803927.svg";
export { ForwardRef as ReactComponent };